import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linkToSchneiderProduct',
    standalone: false
})
export class LinkToSchneiderProductPipe implements PipeTransform {

  transform(refNumber: string , language: string): string {
    if (!refNumber) {
      return '';
    }

    if (language === 'it') {
      language = 'fr'
    }
    if (language === 'en') {
      language = 'de'
    }

    return `https://www.se.com/ch/${ language }/product/${ refNumber }/`;
  }
}
